// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";

// Components
import "./components";

//Plugins
import "./plugins";

// Sync router with store
import { sync } from "vuex-router-sync";

// Application imports
import App from "./App";
import i18n from "@/i18n";
import router from "@/router";
import store from "@/store";
//import Vuetify from "vuetify";
//import theme from "./plugins/theme";
//import "vuetify/dist/vuetify.min.css";
//import "@mdi/font/css/materialdesignicons.css";
//import "material-design-icons-iconfont/dist/material-design-icons.css";
//import axios from "axios";
import "typeface-roboto/index.css";

/** used by adminbot **/
//import LoadScript from "vue-plugin-load-script";
//Vue.use(LoadScript);
//Vue.loadScript("/adminbot/static/js/innvisichat.js");

//Vue.prototype.$http = axios;

// set axios base URL
//if (process.env.NODE_ENV == "production") axios.defaults.baseURL = "";
//else axios.defaults.baseURL = "https://devchat.inn";
//axios.defaults.headers.get["Accept"] = "application/json";

//const token = localStorage.getItem("token");
//if (token) {
//  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
//}

// Sync store with router
sync(store, router);

//Vue.use(Vuetify, {
//  iconfont: "mdi",
//  theme
//});

Vue.config.productionTip = false;
Vue.prototype.location = window.location;

/* eslint-disable no-new */
new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount("#app");
